var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8417 9.64996L10.3417 2.14996C10.0417 1.84996 9.62508 1.66663 9.16675 1.66663H3.33341C2.41675 1.66663 1.66675 2.41663 1.66675 3.33329V9.16663C1.66675 9.62496 1.85008 10.0416 2.15841 10.35L9.65842 17.85C9.95842 18.15 10.3751 18.3333 10.8334 18.3333C11.2917 18.3333 11.7084 18.15 12.0084 17.8416L17.8417 12.0083C18.1501 11.7083 18.3334 11.2916 18.3334 10.8333C18.3334 10.375 18.1417 9.94996 17.8417 9.64996ZM4.58341 5.83329C3.89175 5.83329 3.33341 5.27496 3.33341 4.58329C3.33341 3.89163 3.89175 3.33329 4.58341 3.33329C5.27508 3.33329 5.83342 3.89163 5.83342 4.58329C5.83342 5.27496 5.27508 5.83329 4.58341 5.83329Z",
    fill: "#999999"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "domtour/theme/workation/music/media/category.4eb721491973aae9a79662283efffae8.svg";
export { ForwardRef as ReactComponent };